import { HeadroomLite } from "@nx-paeonia/utils-events";

new HeadroomLite(".header", {
	tolerance: 32,
	offset: document.querySelector(".header")?.getBoundingClientRect()?.height || 0,
});
